<template>
  <v-card :title="xm+' '+dkyf">
    <button @click="exportData">导出数据</button>   
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      border
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xGrid"
      :data="tableData"
      show-footer
      row-id="id"      
      :export-config="{}"
    >      
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
import { milliFormat } from "../../../static/js/milli_format.js";
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      selectRecords: [],
      gh: "",
      xm:"",
      dkyf:"",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          highlight: true,
          range: true,
          reserve: true,
          checkMethod: this.checCheckboxkMethod3
        },
        // editConfig: {
        //   trigger: "", //click可以编辑表格
        //   mode: "row",
        //   showStatus: true,
        // },
        columns: [          
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "dkrq",
            title: "打卡日期",
            align: "center",
          },
          {
            field: "dkqk",
            title: "打卡情况",
            align: "center",
          },
          {
            field: "sbdksj",
            title: "上班打卡时间",
            align: "center",
          },
          {
            field: "sbdkd",
            title: "上班打卡点",
            align: "center",
          },
          {
            field: "xbdksj",
            title: "下班打卡时间",
            align: "center",
          },
          {
            field: "xbdkd",
            title: "下班打卡点",
            align: "center",
          }
        ],
      },
    };
  },
  created() {
    if(this.$route.query.gh){
      this.gh = this.$route.query.gh;
    }
    if(this.$route.query.xm){
      this.xm = this.$route.query.xm;
    }
    if(this.$route.query.dkyf){
      this.dkyf = this.$route.query.dkyf;
    }
    this.findList();
  },
  methods: {
    findList() {      
      this.$axios.get("api/system/dktj/get-dktj3-list?gh=" + this.gh+"&dkyf="+this.dkyf).then((res) => {
        this.tableData = res.data.data;
      });
    },
    exportData() {
      debugger;
      this.$refs.xGrid.exportData({
        type: 'csv',
        filename: '员工打卡明细',
      });
    },
    // footerMethod({ columns, data }) {
    //   return [
    //     columns.map((column, columnIndex) => {
    //       if (columnIndex === 0) {
    //         return "合计";
    //       }
    //       if (["bx_je"].includes(column.property)) {
    //         let sum = 0;
    //         data.forEach((item) => {
    //           sum += item.bx_je;
    //         });
    //         return milliFormat(sum);
    //       }
    //       return null;
    //     }),
    //   ];
    // },
    
  },
};
</script>


<style>
.vxe-footer--row {
  background-color: #ffbf00;
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/view/kqdk/rydkmx.vue